import { render, staticRenderFns } from "./typical_task.vue?vue&type=template&id=51a4ae13&scoped=true"
import script from "./typical_task.vue?vue&type=script&lang=js"
export * from "./typical_task.vue?vue&type=script&lang=js"
import style0 from "./typical_task.vue?vue&type=style&index=0&id=51a4ae13&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a4ae13",
  null
  
)

export default component.exports